// extracted by mini-css-extract-plugin
export default {"product_view":"ProductView_product_view__mG+Q5","product_view__link":"ProductView_product_view__link__OcJKz"};